import React, { useEffect, useState } from 'react';
import { ProviderLayout } from '../../components/layouts';
import StripeConnectOnboarding from '../../components/StripeConnectOnboarding';
import { verificationApi } from '../../api/verificationApi';
import { Alert, Button, Card, CardBody, CardHeader } from '../../components/ui';

const ProviderAccount = () => {
  const [verificationStatus, setVerificationStatus] = useState('pending');
  const [verificationLoading, setVerificationLoading] = useState(true);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setVerificationLoading(true);
    setError('');
    verificationApi.getMyVerification()
      .then((res) => {
        if (!res?.data) throw new Error('Unable to check your profile approval.');
        if (!cancelled) setVerificationStatus(res.data.verificationStatus || 'pending');
      })
      .catch((err) => {
        if (!cancelled) {
          setVerificationStatus('pending');
          setError(err.message || 'Unable to check your profile approval.');
        }
      })
      .finally(() => { if (!cancelled) setVerificationLoading(false); });
    return () => { cancelled = true; };
  }, [attempt]);

  return (
    <ProviderLayout title="Account">
      {error && <Alert variant="danger" className="mb-4">{error}<Button className="mt-3" variant="outline" onClick={() => setAttempt((value) => value + 1)}>Try again</Button></Alert>}
      <Card>
        <CardHeader title="Payout Account" />
        <CardBody>
          <StripeConnectOnboarding verificationStatus={verificationStatus} verificationLoading={verificationLoading} />
        </CardBody>
      </Card>
    </ProviderLayout>
  );
};

export default ProviderAccount;
